<div *ngIf="actualCompany" class="row row-page-title page-row">

  <div class="title-page-col">

    <h1 class="page-title">
      {{ actualCompany.name }}
    </h1>

  </div>

</div>

<p class="page-subtitle sub-alone">
  Informações da Empresa
</p>

<form
  [formGroup]="infoForm"
  *ngIf="infoForm"
  (ngSubmit)="onSubmit()"
  style="text-align: unset"
>

  <div
    *ngIf="infoMotel"
    class="row row-content page-row"
  >

    <div class="col-info-input" style="width: 45%">

      <p class="page-subtitle">
        Data de Expiração da Licença
      </p>

      <input 
        type="date" 
        class="search-input user-input"
        placeholder="Data Limite Acesso" 
        formControlName="iMotelLicenceExpirationDate"
        [ngClass]="{
          'border-red':
            (!infoForm.controls.iMotelLicenceExpirationDate.valid) &&
            (infoForm.controls['iMotelLicenceExpirationDate'].touched)
        }"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !infoForm.controls.iMotelLicenceExpirationDate.valid &&
          infoForm.controls['iMotelLicenceExpirationDate'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-info-input" style="width: 47.3%">

      <p class="page-subtitle">
          Versão InfoMotel
      </p>

      <input
        type="text"
        readonly
        [ngClass]="{
          'border-red':
            (!infoForm.controls.iMotelVersion.valid) &&
            (infoForm.controls['iMotelVersion'].touched)
        }"
        formControlName="iMotelVersion"
        placeholder="Versão InfoMotel"
        class="search-input info-input"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !infoForm.controls.iMotelVersion.valid &&
          infoForm.controls['iMotelVersion'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-info-input" style="width: 45%">

      <p class="page-subtitle">
        Última checagem
      </p>

      <input 
        readonly
        disabled
        type="datetime" 
        [value]="lastCheckFormatted"  
        placeholder="Última checagem" 
        class="search-input user-input"
      >

    </div>
    
    <div class="col-info-input" style="width: 47.3%">
      <button
        type="button"
        class="btn-principal"
        (click)="removeAllData()"
        style="margin-top: 46px;"
      >
        Limpar Dados
      </button>
    </div>

    <div class="col-info-input" style="width: 45%">

      <p class="page-subtitle">
        Licence Json
      </p>

      <textarea
        cols=40
        rows=10
        placeholder="Licence Json"
        class="form-control info-input"
        formControlName="iMotelLicenceJson"
        [ngClass]="{
          'border-red': infoForm.controls.iMotelLicenceJson.invalid && infoForm.touched
        }"
      ></textarea>

      <app-form-errors
        [errorMsg]="'Dado Inválido!'"
        *ngIf="infoForm.controls.iMotelLicenceJson.invalid && infoForm.touched"
      ></app-form-errors>

    </div>

    <div class="col-info-input" style="width: 47.3%">

      <p class="page-subtitle">
        Config Json
      </p>

      <textarea
        cols=40
        rows=10
        placeholder="Config Json"
        class="form-control info-input"
        formControlName="iMotelConfigJson"
        [ngClass]="{
          'border-red': infoForm.controls.iMotelConfigJson.invalid && infoForm.touched 
        }"
      ></textarea>

      <app-form-errors
        [errorMsg]="'Dado Inválido!'"
        *ngIf="infoForm.controls.iMotelConfigJson.invalid && infoForm.touched"
      ></app-form-errors>

    </div>

  </div>

  <div class="col-12 col-alone-btn">

    <button
      type="submit"
      class="btn-principal"
      style="width: 122px; margin-bottom: 30px"
    >
      Salvar
    </button>

  </div>

</form>

<ngx-ui-loader
  [fgsColor]="loaderConfig.fgsColor"
  [fgsPosition]="loaderConfig.fgsPosition"
  [fgsSize]="loaderConfig.fgsSize"
  [fgsType]="loaderConfig.fgsType"
  [bgsColor]="loaderConfig.bgsColor"
  [bgsOpacity]="loaderConfig.bgsOpacity"
  [bgsPosition]="loaderConfig.bgsPosition"
  [bgsSize]="loaderConfig.bgsSize"
  [bgsType]="loaderConfig.bgsType"
  [gap]="loaderConfig.gap"
  [logoPosition]="loaderConfig.logoPosition"
  [logoSize]="loaderConfig.logoSize"
  [logoUrl]="loaderConfig.logoUrl"
  [overlayColor]="loaderConfig.overlayColor"
  [pbColor]="loaderConfig.pbColor"
  [pbDirection]="loaderConfig.pbDirection"
  [pbThickness]="loaderConfig.pbThickness"
  [hasProgressBar]="loaderConfig.hasProgressBar"
  [text]="loaderConfig.text"
  [textColor]="loaderConfig.textColor"
  [textPosition]="loaderConfig.textPosition"
></ngx-ui-loader>

